import en from './en';
import type { TranslationSchema } from './en';

const mr: TranslationSchema = {
    ...en,
};

export default mr;
